<template>
  <div class="container">
    <div @click="clickedNotification()">
      <div class="push__title" v-html="title"></div>
      <div class="push__body" v-html="body"></div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'


export default {
  name: 'PushToast',
  props: ['data'],
  data() {
    return {
    }
  },
  mounted() {
   },
   watch: {
   },
  computed: {
    title: function() {
      if(this.data) {
        if (this.data.title) {
         	return this.data.title;
        }
        if (this.data.aps) {
          if (this.data.aps.alert) {
         		return this.data.aps.alert.title
          }
        }
	     }
      return null;
    },
    body: function() {
	     if(this.data) {
         if (this.data.body) {
            return this.data.body;
         }
         if (this.data.aps) {
           if (this.data.aps.alert) {
              return this.data.aps.alert.body
           }
         }
       }
       return null;
    },

    buttonText: function() {
     	if (this.data) {
      	if (this.data.notificationTypeId) {
         	 if (this.data.notificationTypeId == "new-message") {
            	return "View Request";
           }
        }
      }
      return "View";
    }
  },
  methods: {
    clickedNotification() {
      	Vue.prototype.$bus.$emit("push:clicked", this.data);
        this.$emit('close-toast');
    },
    onSend() {
      // if (this.message.value.trim() != "" && this.message.value != null) {
      //   this.$bus.$emit("message:newMessage", {
      //     message:this.message.value,
      //     replyToId: this.replyToId.value,
      //     done: () => {
      //       this.message.value = "";
      //     }
      //   });
      // }
    }
  }
}
</script>
